/**
 * As chaves de `localStorage` do par de tokens, sozinhas, sem nada em volta.
 *
 * Existe separado de `AuthToken.ts` porque aquele módulo importa `TemporaryTokenManager` (usado só
 * em `deleteAuthCookies`), e a partir dele a árvore alcança o barrel de `account`, o
 * `GraphQLRequester` — que lê `env.graphqlHost` no escopo do módulo — e o `@cobliteam/ui`. Quem
 * precisa apenas do nome das chaves, como `demoLive/demoLiveSession`, importa daqui e não arrasta
 * nada disso para o próprio bundle.
 */
export enum AuthToken {
  REFRESH_TOKEN = 'cobli-refresh-token',
  ACCESS_TOKEN = 'cobli-access-token',
}
